<template>
  <div class="faqs mt-8">
    <section
      class="container mx-auto flex w-full px-4 pb-6 border-b-2 items-center"
    >
      <router-link
        class="cursor-pointer"
        :to="{
          name: 'home',
        }"
      >
        <span class="pointer-events-none"> {{ $t("faqs.home") }} </span>
      </router-link>
      <span class="material-icons mx-4"> chevron_right </span>
      <a class="cursor-pointer">
        <span class="pointer-events-none">{{ $t("faqs.faq") }}</span>
      </a>
    </section>

    <section class="flex flex-col container mx-auto mt-8 px-4">
      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo active"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.1") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.1") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.2") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          <ol>
            <li>
              {{ $t("faqs.answ.2") }}
            </li>
            <li>
              {{ $t("faqs.answ.2_1") }}
            </li>
            <li>
              {{ $t("faqs.answ.2_2") }}
            </li>
          </ol>
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.3") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.3") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.4") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.4") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.5") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.5") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.6") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.6") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.7") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.7") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.8") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.8") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.9") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.9") }}
          <br /><br />
          {{ $t("faqs.answ.9_1") }}
          <br />
          {{ $t("faqs.answ.9_2") }}
          <br />
          {{ $t("faqs.answ.9_3") }}
          <br />
          {{ $t("faqs.answ.9_4") }}
          <br />
          {{ $t("faqs.answ.9_5") }}
          <br />
          {{ $t("faqs.answ.9_6") }}
          <br />
          <br />
          {{ $t("faqs.answ.9_7") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.10") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.10") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.11") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.11") }}
          <br /><br />
          <strong>{{ $t("faqs.answ.11_1") }}</strong>
          <br />
          {{ $t("faqs.answ.11_2") }}
          <br />
          <strong>{{ $t("faqs.answ.11_3") }}</strong>
          <br />
          {{ $t("faqs.answ.11_4") }}
          <br />
          <strong>{{ $t("faqs.answ.11_5") }}</strong>
          <br />
          {{ $t("faqs.answ.11_6") }}
          <br />
          <strong>{{ $t("faqs.answ.11_7") }}</strong>
          <br />
          {{ $t("faqs.answ.11_8") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.12") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.12") }}
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.13") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.13") }}

          <br />
          <div class="flex flex-wrap -mb-1 mt-4">
            <a
              href="https://photo-public.s3.amazonaws.com/suf/attachments/en.pdf"
              type="button"
              class="flex justify-center rounded py-2 px-3 mb-1 bg-grey shadow-lg font-semibold border bg-white border-grey"
              download="en.pdf"  
              target="_blank"        
            >
              <span
                class="isoCurrencyFlag svg"
                style="
                  background-image: url('https://photo-public.s3.amazonaws.com/suf/payments/flags/usd.svg');
                "
              ></span>
              Download
            </a>

            <a
              href="https://photo-public.s3.amazonaws.com/suf/attachments/fr.pdf"
              type="button"
              class="flex justify-center rounded py-2 px-3 mb-1 bg-grey shadow-lg font-semibold border bg-white ml-3 border-grey"
              download="fr.pdf"
              target="_blank"          
            >
              <span
                class="isoCurrencyFlag png"
                style="
                  background-image: url('https://photo-public.s3.amazonaws.com/suf/payments/flags/fr.png');
                "
              ></span>
              Télécharger
            </a>

            <a
              href="https://photo-public.s3.amazonaws.com/suf/attachments/br.pdf"
              type="button"
              class="flex justify-center rounded py-2 px-3 mb-1 bg-grey shadow-lg font-semibold border bg-white ml-3 border-grey"
              download="br.pdf"
              target="_blank"          
            >
              <span
                class="isoCurrencyFlag png"
                style="
                  background-image: url('https://photo-public.s3.amazonaws.com/suf/payments/flags/br.png');
                "
              ></span>
              Descarregar
            </a>

            <a
              href="https://photo-public.s3.amazonaws.com/suf/attachments/ch.pdf"
              type="button"
              class="flex justify-center rounded py-2 px-3 mb-1 bg-grey shadow-lg font-semibold border bg-white ml-3 border-grey"
              download="ch.pdf"
              target="_blank"          
            >
              <span
                class="isoCurrencyFlag svg"
                style="
                  background-image: url('https://photo-public.s3.amazonaws.com/suf/payments/flags/cny.svg');
                "
              ></span>
              下载
            </a>

            <a
              href="https://photo-public.s3.amazonaws.com/suf/attachments/es.pdf"
              type="button"
              class="flex justify-center rounded py-2 px-3 mb-1 bg-grey shadow-lg font-semibold border bg-white ml-3 border-grey"
              download="es.pdf"
              target="_blank"          
            >
              <span
                class="isoCurrencyFlag png"
                style="
                  background-image: url('https://photo-public.s3.amazonaws.com/suf/payments/flags/sp.png');
                "
              ></span>
              Descargar
            </a>
            
          </div>
        </div>
      </div>

      <div
        v-on:click="activeFaqMob"
        class="faqs-Mob border-b border-yellow-photo"
      >
        <div class="faqs-head flex cursor-pointer py-3 px-2 items-center">
          <span class="flex-auto font-bold mr-1 pointer-events-none">
            {{ $t("faqs.qn.14") }}
          </span>
          <span class="material-icons"> expand_more </span>
        </div>

        <div class="faqs-answer px-4 p-4 border-l border-r border-yellow-photo">
          {{ $t("faqs.answ.14") }}
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  components: {},
  data: () => ({}),
  computed: {},
  methods: {
    activeFaq(event) {
      var el = event.target.parentNode;
      var val = event.target;
      var folio = el.querySelectorAll("li");

      for (let i = 0; i < folio.length; i++) {
        folio[i].classList.remove("active");
      }

      val.classList.add("active");
    },

    activeFaqMob(event) {
      var el = event.target.parentNode.parentNode;
      var val = event.target;
      var folio = el.querySelectorAll(".faqs-Mob");

      for (let i = 0; i < folio.length; i++) {
        folio[i].classList.remove("active");
      }

      val.parentNode.classList.toggle("active");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../css/variables.scss";

.faqs-Mob {
  &.active {
    .faqs-head {
      background-color: black;

      color: white;
    }
    .faqs-answer {
      display: block;
    }
  }
  .faqs-answer {
    display: none;
  }
}

.faqs-photo {
  li {
    padding-bottom: 0.75rem;
    padding-top: 0.75rem;
    padding-left: 2rem;
    padding-right: 1rem;
    border-bottom: 1px solid $yellow-photo;
    cursor: pointer;
    &.active {
      background-color: black;
      color: white;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        margin: auto;
        right: -2.4rem;
        width: 0;
        height: 0;
        top: 0px;
        bottom: 0px;
        border-left: 1.2rem solid $yellow-photo;
        border-right: 1.2rem solid transparent;
        border-top: 1.2rem solid transparent;
        border-bottom: 1.2rem solid transparent;
      }

      &::before {
        content: "";
        position: absolute;
        background: url("https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        width: 50px;
        height: 50px;
        display: inline-block;
        left: -2.25rem;
        top: -0.3rem;
      }
    }
  }
}
</style>
